import React, { useState } from 'react';
import { Box, Button, VStack, Heading, Span } from '@bpba/ui-components';
import { useMutation, useQuery } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { Queries } from '../rest/Queries';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { SubmitHandler, useForm, Controller } from 'react-hook-form';
import { Localidad } from '../rest/models/Localidad';
import { getLocalidadesCDNI } from '../rest/queries/getLocalidadesCDNI';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Result } from './Result';
import { ResultExito } from './ResultExito';
import { ResultError } from './ResultError';
import { CreditoDamnificadosBahiaBlancaModel } from '../rest/models/CreditoDamnificadosBahiaBlancaModel';
import { CreditoDamnificadosBahiaBlancaRQ } from '../rest/models/CreditoDamnificadosBahiaBlancaRQ';
import { postCreditoDamnificadosBahiaBlanca } from '../rest/mutations/postCreditoDamnificadosBahiaBlanca';
import ComboSucursales from "./ComboSucursales";


const CreditoDamnificadosBahiaBlancaComponente: React.FC = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let origenSolicitud = params.get('origenSolicitud');

    const { register, handleSubmit, control, reset, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            sucursal: ""
        }
    });

    const REQUIRED_FIELD = "Campo requerido.";
    //eslint-disable-next-line
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;
    const [errorServicio] = useState<boolean>(false);
    const [mensajeError] = useState<string>("");
    const [mensajeErrorPostProspecto] = useState<string>("");
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [idProvinciaCDNI, setIdProvinciaCDNI] = useState<string>();
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<string>("");
    const { executeRecaptcha } = useGoogleReCaptcha();
    const { data: { localidades } = {} } = useQuery<Queries>(getLocalidadesCDNI, { variables: { idProvincia: idProvinciaCDNI }, skip: !idProvinciaCDNI });
    const [postCreditoDamnificadosBahiaBlancaApi, { loading: loadingCreditoBahia }] = useMutation<Mutations>(postCreditoDamnificadosBahiaBlanca);

   

    const onSubmit: SubmitHandler<CreditoDamnificadosBahiaBlancaModel> = async (data: CreditoDamnificadosBahiaBlancaModel) =>  {
       
        const token = executeRecaptcha && (await executeRecaptcha('CreditoDamnificadosBahiaBlanca'));
        
        const datos: CreditoDamnificadosBahiaBlancaRQ = {
            cuit: data.cuit,
            googleToken: token,
            email: data.email,
            nombre: data.nombre,
            razonSocial: data.razonSocial,
            sucursal: Number.parseInt((data.sucursal === "0" ? "1000" : data.sucursal)),
            localidad: ((data.zonaUsr === '1') ? 'CIUDAD DE BUENOS AIRES' : 'BUENOS AIRES') + ',' + data.barrioUsr,
            origenSolicitud: origenSolicitud ? origenSolicitud : 'web',
            telefonoContacto: data.telefonoArea + data.telefono,
            direccion: data.calle + ',' + data.numeroCalle + ',' + (data.piso || '-'),
        }
        
         postCreditoDamnificadosBahiaBlancaApi({ variables: { input: datos } }).then(response => {
           
            setServicioOk(true);
            
            if (response!.data!.creditoDamnificadosBahiaBlancaRS.resultado === "error") {
                
                 if(response!.data!.creditoDamnificadosBahiaBlancaRS.error.toUpperCase().includes("ya tiene una solicitud".toUpperCase())){
                    
                    setMensajeRtaServicio(response!.data!.creditoDamnificadosBahiaBlancaRS.error);
                 
                 }else{
                    
                    setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                 }

            } else {
            
                setMensajeRtaServicio("Hemos recibido tu solicitud. Un/a ejecutivo/a se contactará con vos!.");
            }
        }).catch(() => {
            
            setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
        }) 
       
    }


    function BuscLoc(formId: string) {
        setIdProvinciaCDNI(formId.split('-')[0]);

    }


    if (loadingCreditoBahia) return <SpinnerCajas />;
    const handleReset = () => {
        reset({});
        window.location.reload();
    };

    if (servicioOk) return (

        <Result handleReset={handleReset}>
            <ResultExito message={mensajeRtaServicio}></ResultExito>
        </Result>

    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );


    return (

        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>
                    {errorServicio ?
                        <VStack mt={"20px"}>
                            <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {mensajeError}
                            </Span>
                        </VStack> : <></>
                    }
                     <VStack mt={"20px"}>
                        <input type={"text"} tabIndex={0}
                            {...register("cuit", {
                                required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                maxLength: 11
                            })}
                            name='cuit' id='cuit' placeholder='CUIT/CUIL ej: 30123456789' maxLength={11} minLength={11} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>
                            {errors.cuit ? "* " + errors.cuit.message : ""}
                        </Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input {...register("razonSocial", { required: REQUIRED_FIELD, maxLength: 100 })} name='razonSocial' type={"text"} defaultValue={""} placeholder='Razon social' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.razonSocial ? "* " + errors.razonSocial.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input {...register("nombre", { required: REQUIRED_FIELD, maxLength: 100 })} name='nombre' type={"text"} defaultValue={""} placeholder='Nombre completo' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nombre ? "* " + errors.nombre.message : ""}</Span>
                    </VStack>

                    <VStack mt={"20px"}>
                        <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                    </VStack>
   
                    <VStack mt={"20px"}>
                    <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>                            Teléfono de contacto
                        </Span>
                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Ej.: 11' maxLength={4} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                            </VStack>
                            <VStack>
                                <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Ej.: 4232424' maxLength={14} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                            </VStack>
                        </VStack>
                    </VStack>
                  


                    <VStack mt={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Domicilio Real / Legal </Span>

                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                    style={{ width: "100%" }}
                                    {...register("zonaUsr", { required: REQUIRED_FIELD })}
                                    onChange={(e: any) => BuscLoc(e.target.value)} name="zonaUsr" placeholder='Provincia' >
                                    <option value="">Provincia</option>
                                    <option value="2-Buenos Aires">Buenos Aires</option>
                                    <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.zonaUsr ? "* " + errors.zonaUsr.message : ""}</Span>
                            </VStack>
                            <VStack >
                                <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("barrioUsr", { required: REQUIRED_FIELD })} name="barrioUsr" placeholder='Localidad' >
                                    <option value="" selected >Localidad </option>
                                    {localidades &&
                                        localidades.map((item: Localidad) =>
                                            <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                        )}
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.barrioUsr ? "* " + errors.barrioUsr.message : ""}</Span>
                            </VStack>
                        </VStack>


                        <VStack  mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                        <VStack mr={"0.5rem"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                <input tabIndex={0}{...register("calle", { required: REQUIRED_FIELD, maxLength: 50 })} name="calle" placeholder='Calle' maxLength={50} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calle ? "* " + errors.calle.message : ""}</Span>
                            </VStack>
                            <VStack mr={"0.5rem"}>
                                <input tabIndex={0}{...register("numeroCalle", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalle" placeholder='Nro' maxLength={5} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalle ? "* " + errors.numeroCalle.message : ""}</Span>
                            </VStack>
                            <VStack>
                                <input tabIndex={0}{...register("piso", { required: false, maxLength: 8, })} name="piso" placeholder='Piso' maxLength={8} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.piso?.message}</Span>
                            </VStack>

                        </VStack>
                    </VStack> 


                    <Controller
                                control={control}
                                name="sucursal"
                                rules={{ required: true }}
                                render={({ field }) => {
                                    return <ComboSucursales {...field} onChangeValue={(e) => { field.onChange(e) }} titulo={"Sucursal donde querés finalizar el tramite"} sucursalCliente={0} />
                                }}
                            />

                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.sucursal?.message}</Span>

                    <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>


                </form>
            </VStack>

        </Box>

    )

};



export default CreditoDamnificadosBahiaBlancaComponente;
